import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
export default function PageHeadMetadata(_a) {
    var pagesData = _a.pagesData, generalSettings = _a.generalSettings, isFlyover = _a.isFlyover;
    var defaultCurrentLangItem = pagesData.page.languages && pagesData.page.languages.find(function (it) { return it.isActive; });
    var defaultCurrentUrl = defaultCurrentLangItem && defaultCurrentLangItem.absoluteUrl;
    useEffect(function () {
        var newFavicon = generalSettings && generalSettings.fields.favicon;
        console.log("Load page head metadata: ", newFavicon);
        if (newFavicon) {
            var favicon = document.getElementById('favicon');
            if (favicon) {
                favicon.href = newFavicon;
            }
            else {
                console.error('Favicon element with id "favicon" not found.');
            }
        }
    }, [generalSettings && generalSettings.fields.favicon]);
    return (React.createElement(Helmet, null,
        React.createElement("title", null, pagesData.page.fields.documentPageTitle),
        React.createElement("meta", { name: "description", content: pagesData.page.fields.documentPageDescription }),
        React.createElement("meta", { name: "keywords", content: pagesData.page.fields.documentPageKeyWords }),
        React.createElement("meta", { property: "og:title", content: pagesData.page.fields.ogTitle }),
        React.createElement("meta", { property: "og:description", content: pagesData.page.fields.ogDescription }),
        React.createElement("meta", { property: "og:locale", content: pagesData.culture }),
        React.createElement("meta", { property: "og:image", content: pagesData.page.fields.ogImage }),
        React.createElement("meta", { property: "og:site_name", content: pagesData.page.fields.ogSiteName }),
        React.createElement("meta", { property: "og:type", content: pagesData.page.fields.ogType }),
        React.createElement("meta", { property: "og:url", content: pagesData.page.fields.ogUrl || defaultCurrentUrl }),
        !isFlyover && React.createElement(React.Fragment, null,
            React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
            React.createElement("meta", { name: "twitter:title", content: pagesData.page.fields.ogTitle }),
            React.createElement("meta", { name: "twitter:description", content: pagesData.page.fields.ogDescription }),
            React.createElement("meta", { name: "twitter:site", content: "@SkyLagoonIS" }),
            React.createElement("meta", { name: "twitter:image", content: pagesData.page.fields.ogImage }),
            React.createElement("meta", { name: "twitter:creator", content: "@SkyLagoonIS" })) || null,
        (pagesData.page.languages || '').length && pagesData.page.languages.map(function (lang, index) {
            return React.createElement("link", { rel: "alternate", href: lang.absoluteUrl, hrefLang: lang.culture, key: index });
        }),
        React.createElement("link", { rel: "canonical", href: pagesData.page.fields.canonicalLink || defaultCurrentUrl })));
}
